<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <span style="width: max-content;" class="d-block p-2" *ngIf="this.user.UserType == 'A'">
        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
            <div class="col-2">
                <img *ngIf="this.UserDetails.Photo != null && this.UserDetails.Photo != ''" mat-card-image
                    class="userImage" [src]="common.PhotoLink(this.UserDetails.Photo)" />
                <div *ngIf="this.UserDetails.Photo == null || this.UserDetails.Photo == ''" class="initial-image">
                    <div class="image">
                        {{common.getInitial(this.UserDetails.Name)}}
                    </div>
                </div>
            </div>
            <div class="col-9 userdetail">
                <span class="text-label">{{this.UserDetails.Name}}</span><br />
                <span class="text-label-light">#{{this.UserDetails.EmpCode}}</span><br />
                <span class="text-label-light">{{this.UserDetails.Designation}}</span>
            </div>
        </div>
    </span>

    <form class="g-3" name="PreviousEmploymentForm" (ngSubmit)="Validate(PreviousEmploymentForm)"
        #PreviousEmploymentForm="ngForm" novalidate>
        <div class="card-header">
            Tax Declaration
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <ng-select name="ESS_TaxFinancialYearID" [items]="FinancialYears" bindLabel="FinancialYear"
                        bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Detail.ESS_TaxFinancialYearId"
                        placeholder="Financial Year" [disabled]="isLoad" (change)="setRegime()">
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <div class="btn-group btn-group-toggle" style="width: 100%;">
                        <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name='IsNewRegime'
                                [(ngModel)]="Detail.IsNewRegime" [disabled]="isLoad">
                            Old Regime
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name='IsNewRegime'
                                [(ngModel)]="Detail.IsNewRegime" [disabled]="isLoad">
                            New Regime
                        </label>
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-md-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="LoadDetails()"
                        [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top" *ngIf="!isLoad">
                        Load
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>
                    <button type="button" class="btn btn-outline-danger me-1" (click)="Reset()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top" *ngIf="isLoad">
                        Reset
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>
                </div>
            </div>

            <span *ngIf="changeFinancialYear() as lastDate" class="text-muted fs-6">
                Last Date of declaration: {{ lastDate | date: 'dd MMM yyyy' }}
            </span>

            <ngb-alert [dismissible]="false" type="light" class="alter-text mt-2" *ngIf="this.Message != null">
                <strong><i class="bi bi-info-circle-fill"></i></strong> {{this.Message}}
            </ngb-alert>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardPreviousEmployment?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardPreviousEmployment"
                                    (change)="onSwitchChange($event,'CardPreviousEmployment')" [disabled]="!isLoad">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardPreviousEmployment">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col"></div>
                                <div class="col-auto p-0">
                                    <button type="button" class="btn btn btn-outline-primary btn-sm"
                                        style="margin-bottom: 3px;float: right;" [disabled]="isDisabled"
                                        (click)="Add('CardPreviousEmployment')"><i class="bi bi-plus"
                                            *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Add':'Loading...'}}</button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <!-- <th class="sticky-col">Month</th>
                                                    <th class="sticky-col">Year</th> -->
                                                    <th>Remark</th>
                                                    <th>Basic</th>
                                                    <th>DA</th>
                                                    <th>HRA</th>
                                                    <th>Allowance</th>
                                                    <th>Gross</th>
                                                    <th>PT</th>
                                                    <th>PF</th>
                                                    <th>TDS</th>
                                                    <th>Deduction</th>
                                                    <th>Net</th>
                                                    <th class="sticky-col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of Detail.ESS_TaxPreviousEmploymentDetails; let i = index">
                                                    <!-- <td class="sticky-col">
                                                        <ng-select name="Month{{i}}" [items]="common.monthNames"
                                                            bindLabel="Name" bindValue="Value" placeholder="Month"
                                                            [(ngModel)]="element.Monthname" [selectOnTab]="true"
                                                            (change)="setYear($event,i)" [searchable]="false"
                                                            [clearable]="false" style="width:7rem"
                                                            [appendTo]="'body'"></ng-select>
                                                    </td>
                                                    <td class="sticky-col">
                                                        {{element.Yearname}}
                                                    </td> -->
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. Remark" name="Remarks{{i}}"
                                                            [(ngModel)]="element.Remarks" #Remarks="ngModel"
                                                            maxlength="100" required>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="Basic{{i}}"
                                                            [(ngModel)]="element.Basic" #Basic="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="DA{{i}}"
                                                            [(ngModel)]="element.DA" #DA="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="HRA{{i}}"
                                                            [(ngModel)]="element.HRA" #HRA="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="OtherAllowance{{i}}"
                                                            [(ngModel)]="element.OtherAllowance"
                                                            #OtherAllowance="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <!-- <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="GrossAmount{{i}}"
                                                            [(ngModel)]="element.GrossAmount" #GrossAmount="ngModel"
                                                            pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                                            maxlength="9" required> -->
                                                        <span class="custom-control">{{element.GrossAmount}}</span>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="PT{{i}}"
                                                            [(ngModel)]="element.PT" #PT="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="PF{{i}}"
                                                            [(ngModel)]="element.PF" #PF="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="TDS{{i}}"
                                                            [(ngModel)]="element.TDS" #TDS="ngModel"
                                                            pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="OtherDeduction{{i}}"
                                                            [(ngModel)]="element.OtherDeduction"
                                                            #OtherDeduction="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcGross(i)" maxlength="9">
                                                    </td>
                                                    <td>
                                                        <span class="custom-control">{{element.NetAmount}}</span>
                                                    </td>
                                                    <td class="sticky-col"
                                                        style="align-content: center;text-align: -webkit-center;">
                                                        <i class="bi bi-trash deleteIcon"
                                                            (click)="Delete(i,'CardPreviousEmployment')"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-card-checklist px-2"></i>Chapter VI A Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails')"
                                    [disabled]="!isLoad">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails">
                    <div class="card-body">
                        <div *ngFor="let section of Sections; let i = index">
                            <div class="card my-1"
                                *ngIf="filterSubSection(section.ESS_TaxSectionMasterID,null, false,false).length > 0">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            {{section.SectionCode}} - {{section.SectionName}}
                                        </div>
                                        <div class="col-auto" *ngIf="this.Detail.IsNewRegime?section.IsNewMaxlimitapplicable:section.IsOldMaxlimitapplicable">
                                            Max Limit : {{this.Detail.IsNewRegime?section.NewRegimeMaxAmount:section.OldRegimeMaxAmount}}
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body py-1">
                                    <span class="section-description">Remark : {{section.Description}}</span>
                                    <hr />
                                    <div class="row">
                                        <div class="col">
                                            <ng-select name="ESS_TaxSectionMasterIDSelected{{i}}"
                                                [(ngModel)]="section.ESS_TaxSectionMasterIDSelected"
                                                #ESS_TaxSectionMasterIDSelected="ngModel" placeholder="Sub Section">
                                                <ng-option
                                                    *ngFor="let subsecdata of filterSubSection(section.ESS_TaxSectionMasterID,false,true,false)"
                                                    [value]="subsecdata['ESS_TaxSectionDetailID']">{{subsecdata['SectionCode']}}
                                                    - {{subsecdata['SubSectionName']}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-auto">
                                            <button type="button" class="btn btn btn-outline-primary btn-sm"
                                                style="margin-bottom: 3px;float: right;" [disabled]="isDisabled"
                                                (click)="Add('CardEmpTaxDeclarationDetails',i)"><i class="bi bi-plus"
                                                    *ngIf="!isDisabled"></i>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true" *ngIf="isDisabled"></span>
                                                {{!isDisabled?'Add':'Loading...'}}</button>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Sub Section</th>
                                                    <th>Declared Amount</th>
                                                    <th class="text-end">Approved Amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let subsection of filterSubSection(section.ESS_TaxSectionMasterID,true,true,false); let j = index">
                                                    <td>
                                                        <div style="width: 30rem;">
                                                            {{subsection['SectionCode']}} -
                                                            {{subsection['SubSectionName']}} <span class="ms-2"
                                                                *ngIf="this.Detail.IsNewRegime?subsection['IsNewMaxlimitapplicable']:subsection['IsOldMaxlimitapplicable']">(Limit :
                                                                {{this.Detail.IsNewRegime?subsection['NewRegimeMaxAmount']:subsection['OldRegimeMaxAmount']}})</span>
                                                            <br />
                                                            <span
                                                                class="sub-section-description">{{subsection['SubSectionDescription']}}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style="width: 5rem;">
                                                            <input type="text" class="form-control custom-control"
                                                                placeholder="Ex. 10000"
                                                                name="DeclaredAmount{{subsection['ESS_TaxSectionDetailID']}}{{i}}{{j}}"
                                                                [(ngModel)]="subsection['DeclaredAmount']"
                                                                #DeclaredAmount="ngModel" pattern="^-?[0-9]\d*$"
                                                                [disabled]="subsection['SalaryHeadMasterId'] > 0"
                                                                (keypress)="common.NumberOnly($event,true,true)"
                                                                maxlength="9">
                                                        </div>
                                                    </td>
                                                    <td class="text-end">
                                                        <div style="width: 5rem;">{{!this.IsDraft?subsection['ApprovedAmount']:''}}</div>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;"
                                                        *ngIf="!subsection['IsDefaultSubSection']">
                                                        <i class="bi bi-trash deleteIcon"
                                                            (click)="Delete(subsection['ESS_TaxSectionDetailID'],'CardEmpTaxDeclarationDetails')"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')"
                                    [disabled]="!isLoad">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_HRA">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col"><input type="checkbox" name="IsHouseRented"
                                        [(ngModel)]="Detail.IsHouseRented" ngbCheckbox /> House Rented</div>
                                <div class="col-auto p-0">
                                    <button type="button" class="btn btn btn-outline-primary btn-sm"
                                        style="margin-bottom: 3px;float: right;"
                                        [disabled]="isDisabled || !Detail.IsHouseRented"
                                        (click)="Add('CardEmpTaxDeclarationDetails_HRA')"><i class="bi bi-plus"
                                            *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Add':'Loading...'}}</button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>FromDate</th>
                                                    <th>ToDate</th>
                                                    <th>Monthly Rent</th>
                                                    <th>Name Of Landloard</th>
                                                    <th>Land LordPanNo</th>
                                                    <th>Address</th>
                                                    <th>IsMetroCity</th>
                                                    <th>Approved Amount</th>
                                                    <th class="sticky-col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of Detail.ESS_EmpTaxDeclarationDetails_HRA; let i = index">
                                                    <td>
                                                        <div class="input-group" style="width: 7.5rem;">
                                                            <input class="form-control custom-control-freesize p-0 px-1"
                                                                placeholder="DD MMM YYYY" name="FromDateHAR{{i}}"
                                                                [(ngModel)]="element.FromDate" ngbDatepicker
                                                                #FromDateHAR="ngbDatepicker" [minDate]="MinDate"
                                                                [maxDate]="MaxDate" [container]="'body'" readonly
                                                                [disabled]="!Detail.IsHouseRented" />
                                                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                                                (click)="FromDateHAR.toggle()" type="button"
                                                                [disabled]="!Detail.IsHouseRented"></button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-group" style="width: 7.5rem;">
                                                            <input class="form-control custom-control-freesize p-0 px-1"
                                                                placeholder="DD MMM YYYY" name="ToDateHAR{{i}}"
                                                                [(ngModel)]="element.ToDate" ngbDatepicker
                                                                #ToDateHAR="ngbDatepicker" [minDate]="MinDate"
                                                                [maxDate]="MaxDate" [container]="'body'" readonly
                                                                [disabled]="!Detail.IsHouseRented" />
                                                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                                                (click)="ToDateHAR.toggle()" type="button"
                                                                [disabled]="!Detail.IsHouseRented"></button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="DeclaredAmountHRA{{i}}"
                                                            [(ngModel)]="element.DeclaredAmount"
                                                            #DeclaredAmountHRA="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            maxlength="9" [disabled]="!Detail.IsHouseRented"
                                                            >
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control-freesize"
                                                            placeholder="Ex. Alex" name="NameOfLandlord{{i}}"
                                                            [(ngModel)]="element.NameOfLandlord"
                                                            #NameOfLandlord="ngModel" style="width: 15rem"
                                                            [disabled]="!Detail.IsHouseRented">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. DMMXX0000X" name="LandLordPanNo{{i}}"
                                                            [(ngModel)]="element.LandLordPanNo" #LandLordPanNo="ngModel"
                                                            style="width: 7rem" minlength="10" maxlength="10"
                                                            [disabled]="!Detail.IsHouseRented">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control-freesize"
                                                            placeholder="Ex. Address" name="Address{{i}}"
                                                            [(ngModel)]="element.Address" #Address="ngModel"
                                                            style="width: 15rem" [disabled]="!Detail.IsHouseRented">
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <input type="checkbox" name="IsMetroCity{{i}}"
                                                            [(ngModel)]="element.IsMetroCity"
                                                            [disabled]="!Detail.IsHouseRented" ngbCheckbox />
                                                    </td>
                                                    <td class="text-end">{{!this.IsDraft?element.ApprovedAmount:''}}</td>
                                                    <td style="align-content: center;text-align: -webkit-center;"
                                                        class="sticky-col">
                                                        <i class="bi bi-trash deleteIcon"
                                                            (click)="Delete(i,'CardEmpTaxDeclarationDetails_HRA')"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from Let out
                                Property?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_LOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_LOP"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_LOP')"
                                    [disabled]="!isLoad">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_LOP">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col"><input type="checkbox" name="IsLetOutProperty"
                                        [(ngModel)]="Detail.IsLetOutProperty" ngbCheckbox /> LetOut Property</div>
                                <div class="col-auto p-0">
                                    <button type="button" class="btn btn btn-outline-primary btn-sm"
                                        style="margin-bottom: 3px;float: right;"
                                        [disabled]="isDisabled || !Detail.IsLetOutProperty"
                                        (click)="Add('CardEmpTaxDeclarationDetails_LOP')"><i class="bi bi-plus"
                                            *ngIf="!isDisabled"></i>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'Add':'Loading...'}}</button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Annual Rent Received</th>
                                                    <th>Municipal Taxes</th>
                                                    <th>Net AnnualValue</th>
                                                    <th>Standard Deduction 30%</th>
                                                    <th>Repaying HomeLoan</th>
                                                    <th>Principal Paid OnHomeLoan</th>
                                                    <th>Interest Paid OnHomeLoan</th>
                                                    <th>Name Of TheLender</th>
                                                    <th>Lender PanNo</th>
                                                    <th>NetIncome/Loss</th>
                                                    <th class="sticky-col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of Detail.ESS_EmpTaxDeclarationDetails_LOP; let i = index">
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="AnnualRentReceived{{i}}"
                                                            [(ngModel)]="element.AnnualRentReceived"
                                                            #AnnualRentReceived="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcNet(i)" maxlength="9"
                                                            [disabled]="!Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="MunicipalTaxesPaid{{i}}"
                                                            [(ngModel)]="element.MunicipalTaxesPaid"
                                                            #MunicipalTaxesPaid="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcNet(i)" maxlength="9"
                                                            [disabled]="!Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <span class="custom-control">{{element.NetAnnualValue}}</span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="custom-control">{{element.StandardDeduction}}</span>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <input type="checkbox"
                                                            name="RepayingHomeLoanForThisProperty{{i}}"
                                                            [(ngModel)]="element.RepayingHomeLoanForThisProperty"
                                                            (change)="CalcNet(i)" ngbCheckbox
                                                            [disabled]="!Detail.IsLetOutProperty" />
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="PrincipalPaidOnHomeLoan{{i}}"
                                                            [(ngModel)]="element.PrincipalPaidOnHomeLoan"
                                                            #PrincipalPaidOnHomeLoan="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcNet(i)" maxlength="9"
                                                            [disabled]="!element.RepayingHomeLoanForThisProperty || !Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. 10000" name="InterestPaidOnHomeLoan{{i}}"
                                                            [(ngModel)]="element.InterestPaidOnHomeLoan"
                                                            #InterestPaidOnHomeLoan="ngModel" pattern="^-?[0-9]\d*$"
                                                            (keypress)="common.NumberOnly($event,true,true)"
                                                            (change)="CalcNet(i)" maxlength="9"
                                                            [disabled]="!element.RepayingHomeLoanForThisProperty || !Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control-freesize"
                                                            placeholder="Ex. Alex" name="NameOfTheLender{{i}}"
                                                            [(ngModel)]="element.NameOfTheLender"
                                                            #NameOfTheLender="ngModel" style="width: 15rem"
                                                            [disabled]="!element.RepayingHomeLoanForThisProperty || !Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control custom-control"
                                                            placeholder="Ex. DMMXX0000X" name="LenderPanNo{{i}}"
                                                            [(ngModel)]="element.LenderPanNo" #LenderPanNo="ngModel"
                                                            style="width: 7rem" minlength="10" maxlength="10"
                                                            [disabled]="!element.RepayingHomeLoanForThisProperty || !Detail.IsLetOutProperty">
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="custom-control">{{element.NetIncomeLossFromHouseProperty}}</span>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;"
                                                        class="sticky-col">
                                                        <i class="bi bi-trash deleteIcon"
                                                            (click)="Delete(i,'CardEmpTaxDeclarationDetails_LOP')"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-building px-2"></i>Other Sources of Income
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_Others?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    id="flexSwitchCheckChecked" [checked]="OpenCard.CardEmpTaxDeclarationDetails_Others"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_Others')"
                                    [disabled]="!isLoad">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!this.OpenCard.CardEmpTaxDeclarationDetails_Others">
                    <div class="card-body">
                        <div *ngFor="let section of SectionsOther; let i = index">
                            <div class="card my-1"
                                *ngIf="filterSubSection(section.ESS_TaxSectionMasterID,null, false,true).length > 0">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col">
                                            {{section.SectionCode}} - {{section.SectionName}}
                                        </div>
                                        <div class="col-auto" *ngIf="this.Detail.IsNewRegime?section.IsNewMaxlimitapplicable:section.IsOldMaxlimitapplicable">
                                            Max Limit : {{this.Detail.IsNewRegime?section.NewRegimeMaxAmount:section.OldRegimeMaxAmount}}
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body py-1">
                                    <span class="section-description">Remark : {{section.Description}}</span>
                                    <hr />
                                    <div class="row">
                                        <div class="col">
                                            <ng-select name="ESS_TaxSectionMasterIDSelectedOther{{i}}"
                                                [(ngModel)]="section.ESS_TaxSectionMasterIDSelected"
                                                #ESS_TaxSectionMasterIDSelectedOther="ngModel"
                                                placeholder="Sub Section">
                                                <ng-option
                                                    *ngFor="let subsecdata of filterSubSection(section.ESS_TaxSectionMasterID,false,true,true)"
                                                    [value]="subsecdata['ESS_TaxSectionDetailID']">{{subsecdata['SectionCode']}}
                                                    - {{subsecdata['SubSectionName']}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-auto">
                                            <button type="button" class="btn btn btn-outline-primary btn-sm"
                                                style="margin-bottom: 3px;float: right;" [disabled]="isDisabled"
                                                (click)="Add('CardEmpTaxDeclarationDetails_Others',i)"><i
                                                    class="bi bi-plus" *ngIf="!isDisabled"></i>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true" *ngIf="isDisabled"></span>
                                                {{!isDisabled?'Add':'Loading...'}}</button>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Sub Section</th>
                                                    <th>Declared Amount</th>
                                                    <th class="text-end">Approved Amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let subsection of filterSubSection(section.ESS_TaxSectionMasterID,true,true,true); let j = index">
                                                    <td>
                                                        <div style="width: 30rem;">
                                                            {{subsection['SectionCode']}} -
                                                            {{subsection['SubSectionName']}} <span class="ms-2"
                                                                *ngIf="this.Detail.IsNewRegime?subsection['IsNewMaxlimitapplicable']:subsection['IsOldMaxlimitapplicable']">(Limit :
                                                                {{this.Detail.IsNewRegime?subsection['NewRegimeMaxAmount']:subsection['OldRegimeMaxAmount']}})</span>
                                                            <br />
                                                            <span
                                                                class="sub-section-description">{{subsection['SubSectionDescription']}}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style="width: 5rem;">
                                                            <input type="text" class="form-control custom-control"
                                                                placeholder="Ex. 10000" name="DeclaredAmount{{i}}{{j}}"
                                                                [(ngModel)]="subsection['DeclaredAmount']"
                                                                #DeclaredAmount="ngModel" pattern="^-?[0-9]\d*$"
                                                                [disabled]="subsection['SalaryHeadMasterId'] > 0"
                                                                (keypress)="common.NumberOnly($event,true,true)"
                                                                maxlength="9">
                                                        </div>
                                                    </td>
                                                    <td class="text-end">
                                                        <div style="width: 5rem;">{{!this.IsDraft?subsection['ApprovedAmount']:''}}</div>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;"
                                                        *ngIf="!subsection['IsDefaultSubSection']">
                                                        <i class="bi bi-trash deleteIcon"
                                                            (click)="Delete(subsection['ESS_TaxSectionDetailID'],'CardEmpTaxDeclarationDetails_Others')"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer" *ngIf="isLoad">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" [disabled]="isDisabled"
                        (click)="Cancel()"><i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>

                        {{!isDisabled?'Cancel':'Loading...'}}</button>

                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                        *ngIf="this.isEditAllow && 
                    (this.common.PageRight.IsAdd && this.Detail.ESS_EmpTaxDeclarationID == 0) || (this.common.PageRight.IsEdit && this.Detail.ESS_EmpTaxDeclarationID > 0)"><i
                            class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?this.user.UserType == 'A'?'Save':'Save as Draft':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </form>
</div>